export default __webpack_public_path__ + "content/893634871a6cbff72157198067c72821.woff";